<template>
  <div class="stat-item">
    <div class="stat-header">&nbsp;</div>
    <div class="stat-header">
      <span class="stat-label">{{ label }}</span>
      <span class="stat-value right">{{ total }}</span>
    </div>
    <div class="bar-stacked">
      <div class="bar-segment segment-completed" :style="{ width: `${completedPercent}%` }"></div>
      <div class="bar-segment segment-inprogress" :style="{ width: `${inProgressPercent}%` }"></div>
      <!-- <div class="bar-segment segment-revision" :style="{ width: `${revisionPercent}%` }"></div> -->
      <div class="bar-segment segment-remaining" :style="{ width: `${remainingPercent}%` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StackedBarItem',

  props: {
    label:      { type: String, required: true },
    total:      { type: Number, required: true },
    completed:  { type: Number, required: true },
    inProgress: { type: Number, required: true },
    revision:   { type: Number, required: true }
  },

  computed: {
    completedPercent() {
      if (!this.total || this.total === 0) return 0;
      return Math.round((this.completed / this.total) * 100);
    },

    inProgressPercent() {
      if (!this.total || this.total === 0) return 0;
      return Math.round((this.inProgress / this.total) * 100);
    },

    // revisionPercent() {
    //   if (!this.total || this.total === 0) return 0;
    //   return Math.round((this.revision / this.total) * 100);
    // },

    remainingPercent() {
      const used = this.completedPercent + this.inProgressPercent; //  + this.revisionPercent;
      return Math.max(0, 100 - used);
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 22%;
}

.stat-header {
  display: flex;
  line-height: 0.9em;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
}

.stat-label {
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.stat-value {
  font-size: 12px;
  font-weight: 500;
  color: var(--bs-body-color);

  &.right {
    align-self: flex-end;
    text-align: right;
  }
}

.bar-stacked {
  display: flex;
  height: 3px;
  background: var(--bs-border-color);
  border-radius: 999px;
  overflow: hidden;
  width: 100%;
  margin-top: 6px;
}

.bar-segment {
  height: 100%;
  transition: width 0.3s ease;

  &.segment-completed {
    background: var(--default-status-table-bg-green);
  }

  &.segment-inprogress {
    background: var(--default-status-table-bg-yellow);
  }

  &.segment-revision {
    background: var(--default-status-table-bg-red);
  }

  &.segment-remaining {
    background: var(--bs-border-color);
  }
}
</style>
